import React, { useState } from 'react';
import { FaEnvelope, FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
import './Contact.css';

const ContactForm = () => {
  const FORMSPREE_ENDPOINT = "https://formspree.io/f/xjkoyqay";

  const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '' });
  const [status, setStatus] = useState('');
  const [errors, setErrors] = useState({}); // For custom validation errors

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' }); // Clear error when user types
  };

  // ✅ Custom Validation Logic
  const validateForm = () => {
    let formErrors = {};
    if (!formData.name.trim()) formErrors.name = "Name is required.";
    if (!formData.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      formErrors.email = "Please enter a valid email address.";
    }
    if (formData.phone && !/^[0-9]{10}$/.test(formData.phone)) {
      formErrors.phone = "Phone must be 10 digits (optional field).";
    }
    if (!formData.message.trim()) formErrors.message = "Message cannot be empty.";

    return formErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    setStatus('sending');
    try {
      const response = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus('success');
        setFormData({ name: '', email: '', phone: '', message: '' });
        setErrors({});
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error("Submission error:", error);
      setStatus('error');
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        {/* Left Side Info */}
        <div className="info-panel">
          <h1>Let's contact for better result</h1>
          <div className="divider"></div>
          <div className="info-details">
            <a href="mailto:info@dhanveen.com" className="contact-item">
              <FaEnvelope className="contact-icon" />
              <span>info@dhanveen.com</span>
            </a>
            <div className="contact-item">
              <FaPhoneAlt className="contact-icon" />
              <span>+91 98765 43210</span>
            </div>
            <div className="contact-item">
              <FaMapMarkerAlt className="contact-icon" />
              <span>
                Om complex,<br />
                Keriya bypass road<br />
                Amreli, Gujarat - 365601 <br/>
                India.
              </span>
            </div>
          </div>
        </div>

        {/* Right Side Form */}
        <div className="form-panel">
          <h2>Contact us:</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                className="form-input"
              />
              {errors.name && <p className="error-text">{errors.name}</p>}

              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                className="form-input"
              />
              {errors.email && <p className="error-text">{errors.email}</p>}

              <input
                type="tel"
                name="phone"
                placeholder="Enter Phone (optional)"
                value={formData.phone}
                onChange={handleChange}
                className="form-input"
              />
              {errors.phone && <p className="error-text">{errors.phone}</p>}

              <textarea
                name="message"
                placeholder="Your message..."
                value={formData.message}
                onChange={handleChange}
                className="form-textarea"
              ></textarea>
              {errors.message && <p className="error-text">{errors.message}</p>}
            </div>

            <button type="submit" disabled={status === 'sending'} className="submit-button">
              {status === 'sending' ? 'Sending...' : 'Send now'}
            </button>

            {status === 'success' && <p className="status-success">Message sent successfully!</p>}
            {status === 'error' && <p className="status-error">Oops! Something went wrong.</p>}
          </form>
        </div>
      </div>
    </div>
  );
}

export default ContactForm;
